import React from "react"
import {useSelector} from "react-redux"
import CollapsibleDrawer from "../Common/Layout/CollapsibleDrawer"
import useStoredToggle from "../../core/utils/useStoredToggle"
import useStoredNumber from "../../core/utils/useStoredNumber"
import AiTicketsPanel from "./AiTicketsPanel"

export const AI_TICKETS_PANEL_WIDTH = 250
// Keycloak realm role required to see the panel
export const AI_TICKETS_ROLE = "HERMES_SUPPORT"

/**
 * Right-hand side panel with AI-prepared Zendesk answers awaiting operator approval.
 * Game-agnostic: drop it into any containers/Main/*.js layout.
 *
 * ai-zendesk only has a production environment, so the drawer is hidden in staging mode.
 * Only users with the HERMES_SUPPORT realm role see it.
 */
export default function AiTicketsDrawer() {
    const mode = useSelector((state) => state.data.SourceMode)
    const roles = useSelector((state) => state.data.UserSession?.user?.roles) ?? []
    const [open, toggle, setOpen] = useStoredToggle("hermes.sidePanelOpen", false)
    // expanded width is user-resizable (drag the edge strip) and remembered
    const [width, setWidth] = useStoredNumber("hermes.sidePanelWidth", AI_TICKETS_PANEL_WIDTH)

    if (!mode?.isProd || !roles.includes(AI_TICKETS_ROLE)) return null

    return (
        <CollapsibleDrawer
            anchor="right"
            width={width}
            open={open}
            onToggle={toggle}
            onResize={setWidth}
            minWidth={AI_TICKETS_PANEL_WIDTH}
            maxWidth={800}
            label="AI tickets"
        >
            <AiTicketsPanel open={open} onOpen={() => setOpen(true)}/>
        </CollapsibleDrawer>
    )
}
